import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { api } from '../../services/api';

// Типы для константы
export interface Constant {
  id: number;
  name: string;
  value: number;
  description: string;
}

// Типы для состояния констант
interface ConstantsState {
  constants: Constant[];
  loading: boolean;
  error: string | null;
}

// Асинхронные действия
export const fetchConstants = createAsyncThunk(
  'constants/fetchConstants',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get('/constants');
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message || 'Failed to fetch constants');
    }
  }
);

// Начальное состояние
const initialState: ConstantsState = {
  constants: [],
  loading: false,
  error: null,
};

// Слайс констант
const constantsSlice = createSlice({
  name: 'constants',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch constants
      .addCase(fetchConstants.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchConstants.fulfilled, (state, action) => {
        state.loading = false;
        state.constants = action.payload.data || [];
        console.log('[constants] получены константы:', state.constants.length, 'шт.', state.constants);
      })
      .addCase(fetchConstants.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const { clearError, setLoading } = constantsSlice.actions;
export default constantsSlice.reducer;
